import { ILineCardPricingSectionProps } from '../LineCard.types';
import { useLineCardPricingSectionStyles } from './LineCardPricingSection.styles';
import { useLineEdit } from 'contexts/LineEditContext/LineEditContext.hooks';
import PromotionsSection from '../../Promotions/PromotionsSection';
import SecondaryButton from '../../../../../components/core/ViaeroButton/SecondaryButton/SecondaryButton';
import PriceLine from '../PriceLine/PriceLine';
import ViaeroButton from '../../../../../components/core/ViaeroButton/ViaeroButton';
import HorizontalLine from '../../../../../components/core/HorizontalLine/HorizontalLine';
import PlanDiscountsTag from '../PlanDiscountsTag/PlanDiscountsTag';
import LineCardPricingLineAssurance from './LineCardPricingLine.assurance';
import { ProductType } from 'types/Product';
import { useMemo } from 'react';
import { PlanType } from 'types/Plan';

const LineCardPricingSection = (props: ILineCardPricingSectionProps) => {
    const { item, readonly } = props;

    const styles = useLineCardPricingSectionStyles();

    const { setCurrent } = useLineEdit();

    const HandleAddDevice = () => {
        setCurrent(item.lineNumber - 1);
        window.location.href = '/phones';
    };

    const HandleAddByod = () => {
        setCurrent(item.lineNumber - 1);
        window.location.href = '/plans/select-your-device/bring-your-own-device';
    };

    const HandleAddPlan = () => {
        setCurrent(item.lineNumber - 1);
        window.location.href = '/plans';
    };

    const DeviceUrl = useMemo(() => {
        const productType = item.device?.product.productType as number | undefined;
        const productName = item.device?.product.baseInfo.name;

        if (productType === Object.values(ProductType).indexOf(ProductType.Device)) {
            return `/phones-and-devices/device-details/?view=Devices&device=${productName}`;
        }

        return `/phones-and-devices/device-details/?view=Phone&device=${productName}`;
    }, [item, readonly]);

    const isHomeInternet = useMemo(
        () => item.planSelection?.plan?.planType === PlanType.HomeInternet,
        [item.planSelection?.plan?.planType]
    );

    return (
        <div>
            {item.device && (
                <div className={styles.pricingSectionRoot}>
                    {item.device.downPayment > 0 && (
                        <PriceLine title={'Down Payment'} todayPrice={item.device?.downPayment} />
                    )}

                    {!item.device.useRetailPrice && (
                        <PriceLine
                            title={'Viaero Now! Installment Plan'}
                            monthlyPrice={item.device?.monthlyPrice}
                        />
                    )}

                    {item.device.useRetailPrice && (
                        <PriceLine
                            title={'Full Retail Price'}
                            todayPrice={item.device?.productSku?.sku.price}
                        />
                    )}

                    {item.device.assuranceSku && (
                        <LineCardPricingLineAssurance
                            assuranceSku={item.device.assuranceSku}
                            retailPrice={item.device.product.pricing.retail}
                        />
                    )}

                    <PromotionsSection {...item} />

                    {!readonly && (
                        <a
                            href={DeviceUrl}
                            className={styles.editLink}
                            onClick={(e) => {
                                e.preventDefault();
                                setCurrent(item.lineNumber - 1);
                                window.location.href = DeviceUrl;
                            }}
                        >
                            Edit
                        </a>
                    )}

                    <HorizontalLine />
                </div>
            )}

            {!item.device && !item.byod && !isHomeInternet && (
                <>
                    <div className={styles.addDeviceButtons}>
                        <div>
                            <ViaeroButton
                                click={HandleAddDevice}
                                text={'Shop Devices'}
                                testId={'add-phone-to-line'}
                                className={styles.shopDevicesButton}
                            />
                        </div>

                        <div>
                            <SecondaryButton
                                click={HandleAddByod}
                                text={'Bring Your Own Device'}
                                testId={'add-byod-to-line'}
                                className={styles.byodButton}
                            />
                        </div>
                    </div>

                    <HorizontalLine />
                </>
            )}

            {item.planSelection?.plan && (
                <div className={styles.pricingSectionRoot}>
                    <PriceLine
                        title={item.planSelection.planDisplayName}
                        monthlyPrice={item.planSelection.linePrice}
                    />

                    <PlanDiscountsTag
                        planSelection={item.planSelection}
                        lineNumber={item.lineNumber}
                    />

                    {!readonly && (
                        <a
                            href='/plans'
                            className={styles.editLink}
                            onClick={(e) => {
                                e.preventDefault();
                                setCurrent(item.lineNumber - 1);
                                window.location.href = '/plans';
                            }}
                        >
                            Edit
                        </a>
                    )}
                </div>
            )}

            {!item.planSelection?.plan && (
                <div className={styles.addPlanButtonWrapper}>
                    <SecondaryButton
                        click={HandleAddPlan}
                        text={'Add Plan'}
                        testId={'add-plan-to-line'}
                    />
                </div>
            )}
        </div>
    );
};

export default LineCardPricingSection;
